module.exports = __webpack_public_path__ + "28080ef2f5c2b643b51a4d054382dc9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/barn-house.png
// module id = 2804
// module chunks = 0